import { ChangeDetectionStrategy, Component, ElementRef, Optional, ViewEncapsulation } from '@angular/core';
import { FocusMonitor } from '@angular/cdk/a11y';
import { BaseListComponent } from './base/base-list.component';
import { BaseListItemComponent } from './base/base-list.component';
@Component({
  selector: 'phx-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  exportAs: 'phxList',
  host: {
    class: 'phx-list',
    '[class.phx-list-multi-select]': 'multiple',
    '[class.phx-list-single-select]': 'single',
    '(keydown)': 'onKeydown($event)',
    '(focus)': 'onFocus()',
    role: 'listbox',
    tabindex: '0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PhxListComponent extends BaseListComponent {}

@Component({
  selector: 'phx-list-item, [phx-list-item]',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  inputs: ['disabled'],
  host: {
    role: 'option',
    tabindex: '-2',
    class: 'phx-list-item',
    '[class.phx-list-item-selected]': 'selected',
    '[class.phx-list-item-disabled]': 'disabled',
    '(click)': 'toggleSelected()',
    '(keydown.enter)': 'toggleSelected()',
    '(keydown.space)': 'onSpaceKeyPressed($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PhxListItemComponent extends BaseListItemComponent {
  public onSpaceKeyPressed(event: Event): void {
    event.preventDefault();
    this.toggleSelected();
  }

  constructor(
    @Optional() public selectionList: PhxListComponent,
    protected elementRef: ElementRef,
    protected focusMonitor: FocusMonitor,
    ){
      super(selectionList, elementRef, focusMonitor);
    }

}
